const PATCH_VIEW_MUTATION = `
    mutation logPageView( $pageUrl: String!, $pageType: String ) {
        logPageView( input: { pageUrl: $pageUrl, pageType: $pageType } ) {
            success
        }
    }
`;

const getPageViewMutation = ( options = {} ) => {
    const result = {
        query: PATCH_VIEW_MUTATION,
        operationName: 'logPageView',
        variables: { ...options }
    };

    return JSON.stringify( result );
};

export default getPageViewMutation;
 